import React, { useEffect } from "react";
import Purchase from "../../components/admin/Purchase";


const PurchasePage = () => {

    useEffect(() => {
        document.body.id = "purchase-002";
      }, []);

  return (
    <div>
    <Purchase />
    </div>
  );
};

export default PurchasePage;
